import { useState } from "react";
import CommunityLeftSidebar from "./community/CommunityLeftSidebar";
import CommunityFeed from "./community/CommunityFeed";
import CommunityRightSidebar from "./community/CommunityRightSidebar";
import ClassDetailView from "./community/ClassDetailView";
import CreateClassModal from "./community/CreateClassModal";
import ProfileCard from "./community/ProfileCard";
import PeopleSearch from "./community/PeopleSearch";

import CommunityLeaderboard from "./community/CommunityLeaderboard";
import ClassesDiscovery from "./community/ClassesDiscovery";
import ClubsDiscovery from "./community/ClubsDiscovery";
import CompaniesDiscovery from "./community/CompaniesDiscovery";
import UniversitiesDiscovery from "./community/UniversitiesDiscovery";
import GroupsDiscovery from "./community/GroupsDiscovery";
import { useNavigate } from "react-router-dom";


const CommunityContent = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [showCreateClass, setShowCreateClass] = useState(false);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const navigate = useNavigate();

  const handleOpenProfile = (id) => {
    navigate(`/profile/${id}`);
  };

  return (
    <div className="min-h-screen bg-background">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 py-6">
        <div className="flex gap-6">
          {/* Left Sidebar */}
          <div className="hidden lg:block w-60 flex-shrink-0">
            <div className="sticky top-20">
              <CommunityLeftSidebar
                activeFilter={activeFilter}
                onFilterChange={setActiveFilter}
                onCreateClass={() => setShowCreateClass(true)} />
              
            </div>
          </div>

          {/* Main Feed */}
          <div className="flex-1 min-w-0">
            {selectedClassId ?
            <ClassDetailView classId={selectedClassId} onBack={() => setSelectedClassId(null)} /> :
            activeFilter === "leaderboard" ?
            <CommunityLeaderboard /> :
            activeFilter === "people" ?
            <PeopleSearch onOpenProfile={handleOpenProfile} /> :
            activeFilter === "classes" ?
            <ClassesDiscovery onOpenClass={setSelectedClassId} /> :
            activeFilter === "clubs" ?
            <ClubsDiscovery /> :
            activeFilter === "companies" ?
            <CompaniesDiscovery /> :
            activeFilter === "universities" ?
            <UniversitiesDiscovery /> :
            activeFilter === "groups" ?
            <GroupsDiscovery /> :

            <CommunityFeed
              activeFilter={activeFilter}
              onOpenClass={setSelectedClassId}
              onOpenProfile={handleOpenProfile} />

            }
          </div>

          {/* Right Sidebar */}
          <div className="hidden xl:block w-72 flex-shrink-0">
            <div className="sticky top-20 space-y-4">
                <CommunityRightSidebar />
            </div>
          </div>
        </div>
      </div>

      {showCreateClass && <CreateClassModal onClose={() => setShowCreateClass(false)} />}
      {selectedProfileId !== null && <ProfileCard profileId={selectedProfileId} onClose={() => setSelectedProfileId(null)} />}
    </div>);

};

export default CommunityContent;